














import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { matchTopicMethod } from '@/utils/topicMatch'

type LeftPayloadDOM = Vue & {
  offsetHeight: number
}

@Component
export default class MsgLeftItem extends Vue {
  @Prop({ required: true }) public topic!: string
  @Prop({ required: true }) public qos!: number
  @Prop({ required: true }) public payload!: string
  @Prop({ required: true }) public createAt!: string
  @Prop({ required: true }) public subsList!: SubscriptionModel[]

  private topicColorHeight = '0px'
  private currentTopicColor = ''

  private setCurrentTopicColor() {
    const topic: SubscriptionModel | undefined = this.subsList.find((sub: SubscriptionModel) =>
      matchTopicMethod(sub.topic, this.topic),
    )
    if (topic && topic.color) {
      this.currentTopicColor = topic.color
    }
  }

  private mounted() {
    const leftPayloadDom = this.$refs.leftPayload as LeftPayloadDOM
    this.topicColorHeight = `${leftPayloadDom.offsetHeight - 6}px`
    this.setCurrentTopicColor()
  }
}
